var _g, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgİconSearchLicence(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.751.7v4.349c-.692.372-1.321.845-1.867,1.4V.674c0-.359.315-.674.7-.674h.467c.385,0,.7.315.7.7Z",
    fill: "#fdc520"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.923.441v7.194c-.383.578-.689,1.211-.907,1.883V.441c0-.23.183-.441.44-.441.283,0,.467.211.467.441Z",
    fill: "#fdc520"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.382,0h-.467C.531,0,.215.315.215.674v11.67c0,.411.315.726.674.726h.493c.385,0,.7-.315.7-.7V.701C2.083.315,1.768,0,1.382,0Z",
    fill: "#fdc520"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.249.7v4.411c-.581-.325-1.207-.578-1.867-.746V.7c0-.385.315-.7.7-.7h.467c.385,0,.7.315.7.7Z",
    fill: "#fdc520"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.448.468v3.719c-.306-.04-.618-.061-.934-.064V.468c0-.257.211-.468.468-.468s.467.211.467.468Z",
    fill: "#fdc520"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.087.468v6.068c-.289-.301-.601-.58-.934-.832V.468c0-.257.21-.468.467-.468s.468.211.468.468Z",
    fill: "#fdc520"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.925.468v9.229c-.215-.723-.531-1.4-.933-2.018V.468c0-.257.21-.468.467-.468s.467.211.467.468Z",
    fill: "#fdc520"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.318,0c-.257,0-.467.21-.467.467v12.137c0,.257.21.467.467.467s.467-.21.467-.467V.467C19.785.21,19.574,0,19.318,0Z",
    fill: "#fdc520"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.552.7v3.473c-.65.073-1.276.227-1.867.451V.7c0-.385.315-.7.7-.7h.467c.385,0,.7.315.7.7Z",
    fill: "#fdc520"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.88,11.812c0-2.516,2.039-4.555,4.555-4.555s4.555,2.039,4.555,4.555-2.039,4.555-4.555,4.555-4.555-2.039-4.555-4.555ZM10.435,5.435c-3.522,0-6.377,2.855-6.377,6.377s2.855,6.377,6.377,6.377c1.38,0,2.722-.448,3.826-1.275.026.034.054.067.085.097l2.733,2.733c.362.35.939.34,1.288-.022.341-.353.341-.913,0-1.266l-2.733-2.733c-.03-.031-.063-.059-.097-.085,2.113-2.818,1.542-6.815-1.275-8.928-1.104-.828-2.447-1.275-3.826-1.275Z",
    fill: "#fdc520",
    fillRule: "evenodd"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgİconSearchLicence);
export default __webpack_public_path__ + "static/media/icon_search-licence.50b9cec4e9b4f62cecef2d291cbb05a5.svg";
export { ForwardRef as ReactComponent };